import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BsBell, BsBellFill, BsCheck, BsX, BsCircleFill, BsChevronRight } from 'react-icons/bs';

const SubscriptionAlert = () => {
    const [alerts, setAlerts] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        fetchAlerts();
    }, []);

    useEffect(() => {
        fetchAlerts(); // initial call

        const interval = setInterval(() => {
            fetchAlerts(); // call again every 60 seconds
        }, 60000); // 60,000 ms = 1 minute

        return () => clearInterval(interval); // cleanup
    }, []);


    const fetchAlerts = async () => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/alerts`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });

            setAlerts(response.data);
            setUnreadCount(response.data.filter(alert => !alert.is_read).length);
        } catch (error) {
            console.error('Error fetching alerts:', error);
        }
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
        if (!isOpen && unreadCount > 0) {
            // markAllAsRead();
        }
    };

    const closeDropdown = () => {
        setIsOpen(false);
    };
    const markAsRead = async (alertId, e) => {
        e?.stopPropagation?.(); // safe call

        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/subscription-alerts/mark-read`,
                { alert_ids: [alertId] }, // ✅ Send alert_ids in body
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                }
            );
            setAlerts(prev => prev.filter(alert => alert.id !== alertId));
            setUnreadCount(prev => Math.max(prev - 1, 0));

        } catch (error) {
            console.error('Error marking alert as read:', error);
        }
    };


    // const markAllAsRead = async () => {
    //     try {
    //         const userInfo = JSON.parse(localStorage.getItem('user-info'));
    //         const origin = localStorage.getItem('user-origin');
    //         const token = userInfo?.token;

    //         await axios.patch(
    //             `${process.env.REACT_APP_BACKEND_URL}/api/alerts/mark-all-read`,
    //             {},
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                     'Tenant-Origin': origin,
    //                 },
    //             }
    //         );

    //         setAlerts(alerts.map(alert => ({ ...alert, read: true })));
    //         setUnreadCount(0);
    //     } catch (error) {
    //         console.error('Error marking all alerts as read:', error);
    //     }
    // };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isOpen && !event.target.closest('.notification-container')) {
                closeDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const getAlertIcon = (type) => {
        const baseClass = "flex-shrink-0 mt-1 me-2";
        switch (type) {
            case 'warning':
                return <BsCircleFill className={`${baseClass} text-warning`} size={12} />;
            case 'error':
                return <BsCircleFill className={`${baseClass} text-danger`} size={12} />;
            case 'success':
                return <BsCircleFill className={`${baseClass} text-success`} size={12} />;
            default:
                return <BsCircleFill className={`${baseClass} text-primary`} size={12} />;
        }
    };

    return (
        <div className="notification-container position-relative">
            <button
                className="btn btn-link position-relative p-0"
                onClick={toggleDropdown}
                aria-label="Notifications"
                aria-expanded={isOpen}
            >
                {unreadCount > 0 ? (
                    <BsBellFill size={20} className="text-secondary" />
                ) : (
                    <BsBell size={20} className="text-muted" />
                )}

                {unreadCount > 0 && (
                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger badge-alert">
                        {unreadCount}
                        <span className="visually-hidden">unread notifications</span>
                    </span>
                )}
            </button>

            {isOpen && (
                <div className="position-absolute end-0 mt-2 notification-dropdown bg-white rounded-lg shadow-lg border z-50"
                    style={{ width: '360px' }}>
                    <div className="d-flex justify-content-between align-items-center p-4 border-bottom">
                        <h5 className="m-0 fw-semibold">Notifications</h5>
                        <div className="d-flex align-items-center">
                            {/* {alerts.length > 0 && unreadCount > 0 && (
                                <button
                                    className="btn btn-sm btn-link text-primary p-0 me-2"
                                    // onClick={markAllAsRead}
                                >
                                    Mark all as read
                                </button>
                            )} */}
                            <button
                                className="btn btn-sm btn-link text-muted p-0"
                                onClick={closeDropdown}
                                aria-label="Close notifications"
                            >
                                <BsX size={20} />
                            </button>
                        </div>
                    </div>

                    <div className="notification-list" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                        {alerts.length > 0 ? (
                            alerts.filter(alert => !alert.is_read).map(alert => (

                                <div
                                    key={alert.id}
                                    className={`p-4 border-bottom hover-bg-gray-50 cursor-pointer ${!alert.is_read ? 'bg-gray-50' : ''}`}
                                    onClick={(e) => markAsRead(alert.id, e)}

                                >
                                    <div className="d-flex justify-content-between">
                                        <div className="d-flex">
                                            {getAlertIcon(alert.type)}
                                            <div className="flex-grow-1">
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <p className="mb-1 fw-medium text-dark">{alert.title || 'Notification'}</p>
                                                    {!alert.is_read && (
                                                        <button
                                                            className="btn btn-sm btn-link text-success p-0 ms-2"
                                                            onClick={(e) => markAsRead(alert.id, e)}
                                                            aria-label="Mark as read"
                                                        >
                                                            <BsCheck size={18} />
                                                        </button>
                                                    )}
                                                </div>
                                                <p className="mb-2 small text-muted">{alert.message}</p>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <small className="text-muted">
                                                        {new Date(alert.created_at).toLocaleString()}
                                                    </small>
                                                    <BsChevronRight className="text-muted" size={14} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="p-5 text-center">
                                <BsBell size={28} className="text-muted mb-3 opacity-50" />
                                <p className="mb-0 text-muted">No notifications available</p>
                                <small className="text-muted">You're all caught up!</small>
                            </div>
                        )}
                    </div>

                    {/* {alerts.length > 0 && (
                        <div className="p-3 border-top text-center bg-light">
                            <button className="btn btn-outline-primary btn-sm rounded-pill px-4">
                                View All Notifications
                            </button>
                        </div>
                    )} */}
                </div>
            )}
        </div>
    );
};

export default SubscriptionAlert;